// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { BaseAttribute } from './BaseAttribute';
import { BEInterface } from './BEInterface';
import { PGContext } from '../../../../../../libs/com/MetaPattern/MDA/MD/PGContext';
/**
 * 接口属性 实体类
 * 接口属性
 */
export class InterfaceAttribute extends BaseAttribute {
  /** 接口 的ID */
  private _interface_ID: string;

  /** 获取：接口 的ID */
  public get interface_ID() {
    return this._interface_ID;
  }

  /** 设置：接口 的ID */
  public set interface_ID(value: string) {
    this._interface_ID = value;
  }

  /** 接口  */
  private _interface: BEInterface;

  /** 获取：接口  */
  public get interface() {
    return this._interface;
  }

  /** 设置：接口  */
  public set interface(value: BEInterface) {
    this._interface = value;
    if (value !== null) {
      this.interface_ID = value.id;
    } else {
      this.interface_ID = '';
    }
  }

  constructor() {
    super();
    this._interface_ID = '';
    this._interface = null;
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: InterfaceAttribute, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.interface_ID = element.interface_ID;
      if (hasReference && element.interface !== null) {
        this.interface = element.interface;
      }
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.interface_ID = json.Interface_ID;
    // if (json.Interface !== null) {
    //   this.interface = BEInterface.Create(json.Interface);
    // }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.Interface_ID = this.interface_ID;
  }

  /** 获取属性框上下文（替代元元数据） */
  GetPGContext (): PGContext {
    const context = new PGContext(this.designId, this.displayName);
    super.buildPGContext(context);
    return context;
  }

  static Create(json: any): InterfaceAttribute {
    const interfaceAttribute = new InterfaceAttribute();
    interfaceAttribute.Deserialize(json);
    interfaceAttribute.json = json;
    return interfaceAttribute;
  }
}
